import { NgModule } from '@angular/core';
import { ShopboxCommonModule } from '@shared/common/common.module';
import { LogInComponent } from './pages/login-page/login.component';
import { RouterModule } from '@angular/router';
import { LoginFormComponent } from './components';
import { CheckboxModule } from 'primeng/checkbox';


@NgModule({
    imports: [
        ShopboxCommonModule,
        CheckboxModule,
        RouterModule,
        LogInComponent,
        LoginFormComponent
    ],
})
export class LoginModule { }
